var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZixxarXLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 13.9396V4.70273L27.2982 0L27.0742 0.224055L31.6834 4.83422V13.8085L27.2941 18.1896L22.7288 13.6239L22.5048 13.8479L27.0701 18.4137L18.4302 27.0622L13.799 22.4227L13.5744 22.6463L18.2089 27.2863L13.8159 31.6848H4.85306L0.243803 27.0572L0.0197485 27.2808L4.72156 32H13.9451L18.4307 27.5099L22.9126 32H32V22.8956L27.5182 18.4137L32 13.9396ZM31.6834 23.0271V31.6839H23.0441L18.6547 27.2854L27.295 18.6368L31.6834 23.0271ZM4.78845 13.8732L0.0192871 9.10444L0.243342 8.88039L4.78708 13.4246L13.4439 4.76962L8.88455 0.224964L9.10815 0.000922842L13.8911 4.76962L4.78845 13.8732Z",
    fill: "url(#paint0_linear_2931_23502)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2978 9.10444L9.10815 27.2817H0.0192871V18.1928L18.2089 0H27.2964V9.10444H27.2978ZM0.0192871 9.10444L9.10678 0H0.0192871V9.10444ZM27.2978 18.1928L18.2089 27.2817H27.2964V18.1928H27.2978Z",
    fill: "url(#paint1_linear_2931_23502)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24932 26.1196L8.17463 20.9715L5.73253 23.4136L5.27942 22.9604L8.64609 19.5942L9.09923 20.0474L9.17392 25.1954L11.8057 22.5637L12.2588 23.0168L8.70244 26.5727L8.24932 26.1196Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26282 18.9781L9.9267 18.3142L10.4596 18.8471L9.79572 19.5109L9.26282 18.9781ZM10.2218 19.9375L10.8857 19.2736L13.4437 21.8316L12.7798 22.4955L10.2218 19.9375Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1593 17.0807L13.5761 17.2219L13.435 14.805L14.2886 13.9514L14.4824 17.2745L17.8056 17.4683L16.952 18.3219L14.5351 18.1808L14.6762 20.5977L13.8226 21.4513L13.6288 18.1281L10.3057 17.9343L11.1593 17.0807Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3318 12.9081L17.7487 13.0492L17.6076 10.6324L18.4612 9.77881L18.655 13.1019L21.9781 13.2958L21.1246 14.1493L18.7077 14.0082L18.8488 16.4251L17.9952 17.2787L17.8014 13.9555L14.4783 13.7617L15.3318 12.9081Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3723 11.9308C20.7598 11.3182 21.2349 10.844 21.7077 10.3698L22.8459 9.23168L22.4463 8.83215C22.2864 8.67225 22.1677 8.79093 22.0495 8.90914L20.39 10.5687L19.9905 10.1691L21.6028 8.55678C22.077 8.08257 22.5512 7.60836 23.1638 8.2214L25.1088 10.1668L23.3072 11.9684C22.833 12.4426 22.3588 12.9168 21.7462 12.3038L21.3723 11.9308ZM22.8596 11.616L24.0449 10.4307L23.2454 9.63122L22.06 10.8165C21.9414 10.9352 21.8232 11.0534 21.9831 11.2138L22.4628 11.6935C22.6222 11.8534 22.7409 11.7347 22.8591 11.617L22.8596 11.616Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7321 7.65238C23.1195 7.0398 23.5946 6.56559 24.0675 6.09138L24.7314 5.42749L25.1309 5.82702L24.4198 6.53809C24.3012 6.65676 24.1825 6.77543 24.3429 6.93533L26.3414 8.93345L25.6775 9.59734L23.7321 7.65238Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2931_23502",
    x1: -0.337744,
    y1: 16,
    x2: 32,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#842BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF007E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#FF474B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FF8023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#FFA30A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2931_23502",
    x1: -0.285248,
    y1: 13.6408,
    x2: 27.2978,
    y2: 13.6408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#842BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF007E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#FF474B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FF8023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#FFA30A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZixxarXLogo);
export default __webpack_public_path__ + "static/media/zixxar-x-logo.2183901773f239d9902b4e92014424a9.svg";
export { ForwardRef as ReactComponent };